export const environment = {
  production: true,
  showBranchBanner: false,
  adminUrl: `https://app.timetailor.com`,
  apiUrl: 'https://api.timetailor.com/booking/',
  version: '5d4f199e4b3a059e800d45d0972b21214d0b61c1',
  defaultLocationUuid: '700c5ebe-db11-4655-a5ec-ed7b8eb6e9a5',
  stripePublishableKey:
    'pk_live_51O2fkdCs1Y4LA3vDSoWJA9xPdzAMYruyaS1mA3xfqyMSORyhRuCLazQQOkLZmlNmf2R68V7QaQBA5mLsN4tuIu4r00UIKsHTdy',
  i18nUrl: 'https://translations.timetailor.com/widget/',
  i18nDebug: false,
  envName: 'production',
};
